/* global axios */
import ApiClient from './ApiClient';

class LiveReportsAPI extends ApiClient {
  constructor() {
    super('live_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getConversationMetric(params = {}) {
    return axios.get(`${this.url}/conversation_metrics`, { params });
  }

  getGroupedConversations({ groupBy, inboxId } = { groupBy: 'assignee_id' }) {
    const params = { group_by: groupBy };
    if (inboxId) params.inbox_id = inboxId;
    return axios.get(`${this.url}/grouped_conversation_metrics`, { params });
  }
}

export default new LiveReportsAPI();
